/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AutocompleteItemSchema {
  value: string;
  count: number;
  domain?: string | null;
  category?: string | null;
  lat?: number | null;
  lon?: number | null;
}
